"use strict";

exports.__esModule = true;
exports.MultiFieldSelectorWrapper = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var MultiFieldSelectorWrapper = exports.MultiFieldSelectorWrapper = _styledComponents["default"].div.withConfig({
  displayName: "styles__MultiFieldSelectorWrapper",
  componentId: "sc-1ktpn8v-0"
})(["margin-top:5px;margin-bottom:20px;"]);